import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { setPageTitle } from "../components/DocumentTitle";
import "./NotFound.css";

/**
 * 404 — design-system page for dead/old links.
 */
export default function NotFound() {
  useEffect(() => {
    setPageTitle("Page Not Found — 100ViewsOnly");
  }, []);

  return (
    <div className="nf-page">
      <div className="nf-card">
        <Link to="/" className="nf-logo" aria-label="100ViewsOnly home">
          <Logo size="sm" />
        </Link>
        <p className="nf-code">404</p>
        <h1 className="nf-title">
          This page <em>isn&apos;t here.</em>
        </h1>
        <p className="nf-sub">
          The link may be old, mistyped, or the drop already closed.
          Either way — the window moved on.
        </p>
        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-dark">
            Back to Home
          </Link>
          <Link to="/gallery" className="nf-btn nf-btn-gold">
            Browse Gallery
          </Link>
        </div>
        <p className="nf-hand">not every window stays open</p>
      </div>
    </div>
  );
}
